import { FormattedMessage } from 'react-intl'
import { ModalWrapper, ModalHeader, ModalContent, ModalRow } from './styles'
import Modal from 'components/shared/Modal'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { darkMode } from 'styles/theme'

interface DifferentHoursProps {
    isOpened: boolean
    close: () => void
}

const BlackWeekendUnlimitedDiscountsModal = ({
    isOpened,
    close,
}: DifferentHoursProps) => (
    <Modal
        isOpened={isOpened}
        onClose={close}
        maxWidth={560}
        isBlur
        isMobileCentered
    >
        <ModalWrapper isFullWidth theme={darkMode}>
            <ModalHeader
                pt={[16, 32]}
                pr={[16, 40]}
                pb={[16, 32]}
                pl={[16, 40]}
                theme={darkMode}
            >
                <Text variant="heading3" color="grayscale_200">
                    <FormattedMessage
                        id="promo.black_weekend.unlimited_ticket_discounts_header"
                        defaultMessage="Zniżki na bilety do&nbsp;parku w&nbsp;promocji Black Weekend"
                    />
                </Text>
            </ModalHeader>
            <ModalContent>
                <Text variant="bodyStrong" color="primary_500" mt={24} mb={12}>
                    <FormattedMessage
                        id="promo.black_weekend.unlimited_ticket_discounts_description"
                        defaultMessage="Poniższa wysokość zniżek dotyczy wejścia do parku zarówno w&nbsp;2023&nbsp;r.,&nbsp;jak&nbsp;i&nbsp;2024&nbsp;r."
                        description="Keep the html tags in the translation"
                        values={{
                            span: (chunks: string[]) => (
                                <>
                                    <Text
                                        as="span"
                                        variant="heading4"
                                        color="grayscale_900"
                                    >
                                        {chunks}
                                    </Text>
                                    <br />
                                </>
                            ),
                        }}
                    />
                </Text>
                <Box mt={[4, 12]} mb={[0, 12]} isFullWidth>
                    <ModalRow
                        direction="row"
                        justify="space-between"
                        isFullWidth
                        isFirst
                    >
                        <Text variant="bodySmall" color="grayscale_0">
                            <FormattedMessage
                                id="promo.black_weekend.unlimited_ticket_discounts_01"
                                defaultMessage="Styczeń - Luty"
                            />
                        </Text>
                        <Text variant="bodySmall" color="grayscale_0">
                            -25%
                        </Text>
                    </ModalRow>
                    <ModalRow
                        direction="row"
                        justify="space-between"
                        isFullWidth
                    >
                        <Text variant="bodySmall" color="grayscale_0">
                            <FormattedMessage
                                id="promo.black_weekend.unlimited_ticket_discounts_02"
                                defaultMessage="Marzec"
                            />
                        </Text>
                        <Text variant="bodySmall" color="grayscale_0">
                            -50%
                        </Text>
                    </ModalRow>
                    <ModalRow
                        direction="row"
                        justify="space-between"
                        isFullWidth
                    >
                        <Text variant="bodySmall" color="grayscale_0">
                            <FormattedMessage
                                id="promo.black_weekend.unlimited_ticket_discounts_03"
                                defaultMessage="Kwiecień - Czerwiec"
                            />
                        </Text>
                        <Text variant="bodySmall" color="grayscale_0">
                            -40%
                        </Text>
                    </ModalRow>
                    <ModalRow
                        direction="row"
                        justify="space-between"
                        isFullWidth
                    >
                        <Text variant="bodySmall" color="grayscale_0">
                            <FormattedMessage
                                id="promo.black_weekend.unlimited_ticket_discounts_04"
                                defaultMessage="Lipiec - Sierpień"
                            />
                        </Text>
                        <Text variant="bodySmall" color="grayscale_0">
                            -30%
                        </Text>
                    </ModalRow>
                    <ModalRow
                        direction="row"
                        justify="space-between"
                        isFullWidth
                    >
                        <Text variant="bodySmall" color="grayscale_0">
                            <FormattedMessage
                                id="promo.black_weekend.unlimited_ticket_discounts_05"
                                defaultMessage="Wrzesień - Październik"
                            />
                        </Text>
                        <Text variant="bodySmall" color="grayscale_0">
                            -60%
                        </Text>
                    </ModalRow>
                    <ModalRow
                        direction="row"
                        justify="space-between"
                        isFullWidth
                    >
                        <Text variant="bodySmall" color="grayscale_0">
                            <FormattedMessage
                                id="promo.black_weekend.unlimited_ticket_discounts_06"
                                defaultMessage="Listopad - Grudzień"
                            />
                        </Text>
                        <Text variant="bodySmall" color="grayscale_0">
                            -30%
                        </Text>
                    </ModalRow>
                </Box>
            </ModalContent>
        </ModalWrapper>
    </Modal>
)

export default BlackWeekendUnlimitedDiscountsModal
